(function () {
  'use strict';

  var RESTORATION_TYPES = ['refresh', 'revive', 'reborn'];

  function isRestoration(title) {
    return RESTORATION_TYPES.some(function(t) {
      return (title || '').toLowerCase().indexOf(t) !== -1;
    });
  }

  function fmt(n) { return '£' + (n / 100).toFixed(2); }
  function ce(t) { return document.createElement(t); }
  function ge(id) { return document.getElementById(id); }

  /* ── UK sizes for dropdowns ── */
  var UK_SIZES = [];
  for (var s = 3; s <= 15; s++) {
    UK_SIZES.push('UK ' + s);
    if (s < 15) UK_SIZES.push('UK ' + s + '.5');
  }

  /* ── Fetch cart and build forms ── */
  function loadCart(cb) {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(cb).catch(function() { cb(null); });
  }

  function saveLineItemProp(key, value, line, cb) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: line,
        properties: key
      })
    }).then(function(r) { return r.json(); }).then(cb).catch(function() { if (cb) cb(null); });
  }

  /* ── Build a single pair detail form ── */
  function buildPairForm(item, lineIndex) {
    var existing = item.properties || {};
    var wrap = ce('div');
    wrap.className = 'cpd-pair-form';
    wrap.setAttribute('data-line', lineIndex);
    wrap.setAttribute('data-key', item.key);

    var header = ce('div');
    header.className = 'cpd-pair-header';
    var img = ce('div');
    img.className = 'cpd-pair-img';
    if (item.image) {
      var im = ce('img');
      im.src = item.image;
      im.alt = item.product_title;
      img.appendChild(im);
    } else {
      img.innerHTML = '<span>👟</span>';
    }
    var info = ce('div');
    info.className = 'cpd-pair-info';
    var pairNum = ce('p');
    pairNum.className = 'cpd-pair-num';
    pairNum.textContent = 'Pair ' + lineIndex;
    var svcName = ce('p');
    svcName.className = 'cpd-pair-svc';
    svcName.textContent = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '');
    var svcPrice = ce('p');
    svcPrice.className = 'cpd-pair-price';
    svcPrice.textContent = fmt(item.final_line_price);
    info.appendChild(pairNum);
    info.appendChild(svcName);
    info.appendChild(svcPrice);
    header.appendChild(img);
    header.appendChild(info);
    wrap.appendChild(header);

    /* Fields */
    var fields = ce('div');
    fields.className = 'cpd-fields';

    /* Trainer model */
    var mLabel = ce('label');
    mLabel.className = 'cpd-label';
    mLabel.innerHTML = 'TRAINER MODEL <span class="cpd-req">*</span>';
    var mInput = ce('input');
    mInput.type = 'text';
    mInput.className = 'cpd-input';
    mInput.placeholder = 'e.g. Nike Air Force 1, Adidas Samba';
    mInput.value = existing['Trainer Model'] || '';
    mInput.id = 'cpd-model-' + lineIndex;

    /* UK size */
    var sLabel = ce('label');
    sLabel.className = 'cpd-label';
    sLabel.innerHTML = 'UK SIZE <span class="cpd-req">*</span>';
    var sWrap = ce('div');
    sWrap.className = 'cpd-select-wrap';
    var sSelect = ce('select');
    sSelect.className = 'cpd-select';
    sSelect.id = 'cpd-size-' + lineIndex;
    var blank = ce('option'); blank.value = ''; blank.textContent = 'Select size…';
    sSelect.appendChild(blank);
    UK_SIZES.forEach(function(sz) {
      var o = ce('option'); o.value = sz; o.textContent = sz;
      if (existing['UK Size'] === sz) o.selected = true;
      sSelect.appendChild(o);
    });
    sWrap.appendChild(sSelect);

    /* Notes */
    var nLabel = ce('label');
    nLabel.className = 'cpd-label';
    nLabel.textContent = 'EXTRA NOTES (optional)';
    var nInput = ce('input');
    nInput.type = 'text';
    nInput.className = 'cpd-input';
    nInput.placeholder = 'e.g. heavy creasing on toe box, yellowed sole…';
    nInput.value = existing['Extra Notes'] || '';
    nInput.id = 'cpd-notes-' + lineIndex;

    fields.appendChild(mLabel);
    fields.appendChild(mInput);
    fields.appendChild(sLabel);
    fields.appendChild(sWrap);
    fields.appendChild(nLabel);
    fields.appendChild(nInput);

    /* Save status */
    var status = ce('p');
    status.className = 'cpd-status';
    status.id = 'cpd-status-' + lineIndex;
    if (existing['Trainer Model'] && existing['UK Size']) {
      status.textContent = '✅ Details saved';
      status.className = 'cpd-status cpd-status--ok';
      wrap.classList.add('cpd-pair-form--complete');
    }

    /* Save button */
    var saveBtn = ce('button');
    saveBtn.type = 'button';
    saveBtn.className = 'cpd-save-btn';
    saveBtn.textContent = 'Save pair details';
    saveBtn.setAttribute('data-line', lineIndex);

    fields.appendChild(status);
    fields.appendChild(saveBtn);
    wrap.appendChild(fields);

    /* Save handler */
    saveBtn.addEventListener('click', function() {
      var model = ge('cpd-model-' + lineIndex).value.trim();
      var size  = ge('cpd-size-'  + lineIndex).value;
      var notes = ge('cpd-notes-' + lineIndex).value.trim();

      ge('cpd-model-' + lineIndex).style.borderColor = model ? '' : '#c0392b';
      ge('cpd-size-'  + lineIndex).style.borderColor = size  ? '' : '#c0392b';

      if (!model || !size) {
        status.textContent = '⚠ Please fill in trainer model and size.';
        status.className = 'cpd-status cpd-status--err';
        return;
      }

      saveBtn.disabled = true;
      saveBtn.textContent = 'Saving…';

      var props = {
        'Trainer Model': model,
        'UK Size': size
      };
      if (notes) props['Extra Notes'] = notes;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, properties: props })
      }).then(function(r) { return r.json(); }).then(function() {
        saveBtn.disabled = false;
        saveBtn.textContent = 'Save pair details';
        status.textContent = '✅ Details saved';
        status.className = 'cpd-status cpd-status--ok';
        wrap.classList.add('cpd-pair-form--complete');
        checkAllComplete();
      }).catch(function() {
        saveBtn.disabled = false;
        saveBtn.textContent = 'Save pair details';
        status.textContent = '⚠ Save failed — please try again.';
        status.className = 'cpd-status cpd-status--err';
      });
    });

    return wrap;
  }

  /* ── Check all forms complete, unlock checkout ── */
  function checkAllComplete() {
    var forms = document.querySelectorAll('.cpd-pair-form');
    var allDone = true;
    forms.forEach(function(f) {
      if (!f.classList.contains('cpd-pair-form--complete')) allDone = false;
    });
    var notice = ge('cpd-checkout-notice');
    var checkoutBtns = document.querySelectorAll('[name="checkout"], .cart__checkout-button, button[data-action="checkout"], a[href="/checkout"]');
    if (allDone) {
      if (notice) notice.style.display = 'none';
      checkoutBtns.forEach(function(b) { b.removeAttribute('disabled'); b.style.opacity = ''; b.style.pointerEvents = ''; });
    } else {
      if (notice) notice.style.display = 'flex';
      checkoutBtns.forEach(function(b) { b.setAttribute('disabled', 'disabled'); b.style.opacity = '0.45'; b.style.pointerEvents = 'none'; });
    }
  }

  /* ── Inject styles ── */
  function injectStyles() {
    if (ge('cpd-styles')) return;
    var st = ce('style'); st.id = 'cpd-styles';
    st.textContent = [
      '@import url("https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&display=swap");',
      '.cpd-wrap { font-family:"Space Grotesk",sans-serif; width:100%; margin:32px 0 24px; }',
      '.cpd-wrap * { font-family:"Space Grotesk",sans-serif; box-sizing:border-box; }',
      '.cpd-heading { font-size:20px; font-weight:700; text-transform:uppercase; letter-spacing:0.08em; color:#1A1A1A; margin:0 0 6px; }',
      '.cpd-subheading { font-size:15px; color:#666; margin:0 0 20px; }',
      '.cpd-pair-form { border:2px solid #DDDDD8; border-radius:16px; padding:20px 24px; margin-bottom:16px; transition:border-color 0.2s; }',
      '.cpd-pair-form--complete { border-color:#264C21; background:#fafffe; }',
      '.cpd-pair-header { display:flex; align-items:center; gap:14px; margin-bottom:18px; padding-bottom:14px; border-bottom:1px solid #f0f0f0; }',
      '.cpd-pair-img { width:56px; height:56px; border-radius:10px; overflow:hidden; background:#f0f0f0; flex-shrink:0; display:flex; align-items:center; justify-content:center; }',
      '.cpd-pair-img img { width:100%; height:100%; object-fit:cover; }',
      '.cpd-pair-img span { font-size:1.8rem; }',
      '.cpd-pair-num { font-size:11px; font-weight:700; letter-spacing:0.12em; text-transform:uppercase; color:#264C21; margin:0 0 3px; }',
      '.cpd-pair-svc { font-size:15px; font-weight:700; color:#1A1A1A; margin:0 0 2px; }',
      '.cpd-pair-price { font-size:14px; color:#4A4A48; font-weight:600; margin:0; }',
      '.cpd-fields { display:grid; grid-template-columns:1fr 1fr; gap:12px 20px; }',
      '.cpd-label { font-size:12px; font-weight:700; letter-spacing:0.08em; text-transform:uppercase; color:#4A4A48; display:block; margin-bottom:5px; grid-column:auto; }',
      '.cpd-req { color:#c0392b; }',
      '.cpd-input { width:100%; padding:10px 13px; border:1.5px solid #DDDDD8; border-radius:8px; font-size:15px; font-weight:500; color:#1A1A1A; background:#F8F8F6; }',
      '.cpd-input:focus { border-color:#264C21; outline:none; box-shadow:0 0 0 3px rgba(45,90,39,0.1); }',
      '.cpd-select-wrap { position:relative; }',
      '.cpd-select-wrap::after { content:"▾"; position:absolute; right:12px; top:50%; transform:translateY(-50%); pointer-events:none; color:#666; }',
      '.cpd-select { width:100%; padding:10px 32px 10px 13px; border:1.5px solid #DDDDD8; border-radius:8px; font-size:15px; font-weight:500; color:#1A1A1A; background:#F8F8F6; appearance:none; -webkit-appearance:none; cursor:pointer; }',
      '.cpd-select:focus { border-color:#264C21; outline:none; }',
      '.cpd-status { font-size:13px; font-weight:600; margin:8px 0 0; grid-column:1/-1; }',
      '.cpd-status--ok { color:#264C21; }',
      '.cpd-status--err { color:#c0392b; }',
      '.cpd-save-btn { grid-column:1/-1; width:100%; padding:12px; background:#1A1A1A; color:#F8F8F6; border:none; border-radius:8px; font-size:15px; font-weight:700; cursor:pointer; margin-top:4px; transition:background 0.2s; }',
      '.cpd-save-btn:hover { background:#264C21; }',
      '.cpd-checkout-notice { background:#F8F8F68e6; border:1.5px solid #f0c040; border-radius:10px; padding:12px 16px; margin-top:8px; display:flex; align-items:center; gap:10px; font-size:14px; font-weight:600; color:#7a5c00; }',
      '@media(max-width:600px) { .cpd-fields { grid-template-columns:1fr; } }'
    ].join('\n');
    document.head.appendChild(st);
  }

  /* ── Main init ── */
  function init() {
    var mount = ge('cpd-mount');
    if (!mount) return;

    injectStyles();

    loadCart(function(cart) {
      if (!cart || !cart.items) return;

      var restorationItems = cart.items.filter(function(item) {
        return isRestoration(item.product_title);
      });

      if (!restorationItems.length) {
        mount.innerHTML = '';
        return;
      }

      mount.innerHTML = '';
      var wrap = ce('div');
      wrap.className = 'cpd-wrap';

      var heading = ce('h2');
      heading.className = 'cpd-heading';
      heading.textContent = 'Trainer Details';
      var sub = ce('p');
      sub.className = 'cpd-subheading';
      sub.textContent = 'Please fill in the details for each pair before checking out.';
      wrap.appendChild(heading);
      wrap.appendChild(sub);

      restorationItems.forEach(function(item, i) {
        var lineIndex = cart.items.indexOf(item) + 1;
        wrap.appendChild(buildPairForm(item, lineIndex));
      });

      /* Checkout blocker notice */
      var notice = ce('div');
      notice.id = 'cpd-checkout-notice';
      notice.className = 'cpd-checkout-notice';
      notice.style.display = 'none';
      notice.innerHTML = '⚠️ <span>Please save trainer details for all pairs before checking out.</span>';
      wrap.appendChild(notice);

      mount.appendChild(wrap);
      checkAllComplete();
    });
  }

  /* Re-init on cart updates */
  document.addEventListener('cart:updated', function() { setTimeout(init, 300); });
  document.addEventListener('cart:refresh', function() { setTimeout(init, 300); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());